import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';

const analytics = Analytics({
  app: 'Adminix',
  plugins: [
    googleTagManager({
      containerId: 'G-2V2BDENVS0',
    }),
  ],
});

document.addEventListener('turbo:load', () => {
  analytics.page();
});
